import { render, staticRenderFns } from "./OperaCouponUsedDetail.vue?vue&type=template&id=d800257c&scoped=true&"
import script from "./OperaCouponUsedDetail.vue?vue&type=script&lang=js&"
export * from "./OperaCouponUsedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d800257c",
  null
  
)

export default component.exports